import React, { useEffect }  from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import RecruitmentOverviewTabs from "./components/OveriewTab";
import { 
    Users,
    UserPlus,
    TrendingUp,
    CheckCircle,
    ArrowLeft,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { getRecruitmentStat } from "../../../redux/recruitment/recruitmentState";

const RecruitmentOverview = ({recordStat, getStats}) => {

    useEffect(() => {
        getStats();
    }, [getStats]);

    const navigate = useNavigate();
    const location = useLocation();

    const navFromQuickAccess = location.state?.fromQuickAccess;

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6">
                {navFromQuickAccess && (
                    <button
                        onClick={() => navigate("/console/dashboard")}
                        className="flex items-center border rounded-xl px-2 py-1 gap-2 dark:text-white mb-4"
                    >
                        <ArrowLeft className="w-4 h-4 dark:text-white"/>
                        Back to Dashboard
                    </button>
                )}
                <SummaryHeader
                    title={"Recruitment Overview"}
                    icon={Users}
                    description={"Track candidate progress and build your dream team"}
                    color={"green"}
                >
                    <div className="summary-item-container">
                        <SummaryItem
                            title="Active Candidates"
                            icon={<UserPlus />}
                            display={recordStat?.active_candidates || 0}
                        />
                        <SummaryItem
                            title="Avg. Time to Hire"
                            icon={<TrendingUp />}
                            display={`${recordStat?.average_time_to_hire || 0} days`} 
                        />
                        <SummaryItem
                            title="Offers Extended"
                            icon={<CheckCircle />}
                            display={recordStat?.offers_extended || 0} 
                        />
                    </div>
                </SummaryHeader>
                <RecruitmentOverviewTabs />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordStat: state.recruitment.recruitmentStat?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getStats: (data) => dispatch(getRecruitmentStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecruitmentOverview);